export const COMPETITOR1 = "{$competitor1}";
export const COMPETITOR2 = "{$competitor2}";
export const DRAW = "draw";

export const onex2Type = [COMPETITOR1, COMPETITOR2, DRAW, "1", "x", "2"];
export const localSportsIds = ["1", "2", "5", "10", "117", "16", "3"];
export const sponserTeamHoverUrl = "/images/sponsored-trophy.svg";
export const TeamCommonImgUrl = "/images/trophy.svg";
export const TeamCommonImgServerUrl =
  process.env.REACT_APP_TEAM_COMMON_IMAGE_SERVERURL;
export const tennisProviderSportId = "5";

export const statusCode = {
  ended: "3"
};
export const pollingTime = 240000;
export const oddsFormats = ["Decimal", "American", "Fractional"];

export const DateTimeFilter = [
  { all: "SUBHEADER.ALL" },
  { "1h": "1h" },
  { "2h": "2hs" },
  { "3h": "3hs" },
  { "6h": "6hs" },
  { "12h": "12hs" },
  { "24h": "24hs" },
  { "48h": "48hs" }
];

export const DATE_FORMAT = "DD/MM/YYYY";

export const MyBetFilter = [
  { All: "SUBHEADER.ALL" },
  { InGame: "SUBHEADER.IN GAME" },
  { Won: "SUBHEADER.WON" },
  { Loss: "SUBHEADER.LOSS" },
  { CashOut: "SUBHEADER.COLLECTED" },
  { Refund: "SUBHEADER.REFUND" },
  { HalfWon: "SUBHEADER.HalfWon" },
  { HalfLost: "SUBHEADER.HalfLost" }
];

export const MyBetFilterTabs = [
  { All: "SUBHEADER.ALL" },
  { InGame: "SUBHEADER.IN GAME" },
  { Won: "SUBHEADER.WON" },
  { Loss: "SUBHEADER.LOSS" },
  { CashOut: "SUBHEADER.COLLECTED" },
  { Refund: "SUBHEADER.REFUND" }
];

export const settlementStatus = {
  InGame: "in_game",
  Won: "won",
  Loss: "lost",
  cashout: "cashout",
  Refund: "refund",
  HalfWon: "half_won",
  HalfLost: "half_lost"
};

export const DefaultImage = "/images/sportsbook/default-sport.svg";
export const activeDefaultImage = "/images/sportsbook/active-default-sport.svg";

export const ODD_TO_TEAMNAME_MARKETID = {
  live: [
    "2_", //3way,
    "4_", // Handicap
    "6_285", //2nd Half - 3way,
    "6_1372", //2nd Half - 3way, including overtime
    "6_954", //3way for first period
    "6_960", //3way for fourth period
    "6_956", //3way for second period
    "6_958", //3way for third period
    "6_22", //Halftime - 3way
    "6_101", //Handicap for first half
    "6_2050", //Handicap for first quarter
    "6_2051", //Handicap for second quarter
    "6_2052", //Handicap for third quarter
    "6_2064", //Winning Margin 3-Way
    "7_2084", //1st Point Winner Game
    "7_1368", //2nd Half - Asian handicap, including overtime
    "7_34", //Asian Handicap
    "7_36", //Asian handicap first half
    "7_76", //Asian handicap for fifth period
    "7_44", //Asian handicap for first period
    "7_54", //Asian handicap for fourth period
    "7_48", //Asian handicap for second period
    "7_51", //Asian handicap for third period
    "7_38", //Asian handicap for whole match, including overtime
    "7_16", //Draw No Bet
    "7_61", //Draw No Bet first half
    "7_41", //Draw No Bet for first period
    "7_52", //Draw no Bet for fourth period
    "7_46", //Draw no Bet for second period
    "7_49", //Draw No Bet for third period
    "7_924", //Game Handicap for set [setNr]
    "7_922", //Match Game Handicap
    "7_2313", //Match Tie Break Handicap
    "7_2304", //Match Tie-Break Winner
    "7_2308", //Set Tie Break Handicap
    "7_2303", //Set Tie Break Winner
    "7_10", //Which player will win the match?
    "7_11", //Which player will win the set
    "7_102", //Which team will win the match?
    "7_37", //Which team will win the match, including overtime
    "7_106", //Which team will win the match, including overtime and penalties?
    "7_103", //Which team will win the set?
    "7_75", //Which team wins race to X points, fifth set?
    "7_71", //Which team wins race to X points, first set?
    "7_74", //Which team wins race to X points, fourth set?
    "7_72", //Which team wins race to X points, second set?
    "7_73", //Which team wins race to X points, third set?
    "7_228", //Who advances to next round?
    "7_81", //Who scores Xth point fifth set
    "7_77", //Who scores Xth point first set
    "7_80", //Who scores Xth point fourth set
    "7_64", //Who scores Xth point, including overtime
    "7_78", //Who scores Xth point second set
    "7_79", //Who scores Xth point third set
    "7_89", //Who wins game X?,
    "8_2026", //1st Half 3-Way Total,
    "8_1527", //1st Half - Both teams to score
    "8_2059", //1st Half Winning Margin
    "8_2060", //1st Quarter Winning Margin
    "8_287", //Double chance (1X - 12 - X2)
    "8_1344", //Odd/Even, including overtime
    "8_2061", //2nd Quarter Winning Margin
    "8_2062", //3rd Quarter Winning Margin
    "8_27", //Double chance (1X - 12 - X2)
    "8_1044", //Double chance for [periodNr!] period
    "8_325", //Halftime - Double chance (1X - 12 - X2)
    "8_237", //Halftime/fulltime
    "8_1040", //Matchbet and both teams to score
    "8_2124", //Match Odd/Even
    "8_31", //Odd/Even
    "8_974", //Odd/Even
    "8_69", //Odd/Even for fifth period
    "8_62", //Odd/Even for first half
    "8_45", //Odd/Even for first period
    "8_60", //Odd/Even for fourth period    ,
    "8_58", //Odd/Even for second period
    "8_59", //Odd/Even for third period
    "8_94", //Odd/Even number of games
    "8_2126" //Period Winning Margin
    // "8_2072", //Set 1 Correct Score
    // "8_2073", //Set 2 Correct Score
    // "8_2074", //Set 3 Correct Score
    // "8_2075", //Set 4 Correct Score
    // "8_2076", //Set 5 Correct Score
    // "8_2081", //Set Correct Score Any Player
    // "8_2082" //Set Correct Score Group
  ],
  preLive: [
    "1", // 1x2
    "2", //To qualify
    "219", //Winner (incl. overtime)
    "186", //Winner
    "57", //{$competitor2} to score in both halves
    "62", //1st half - {!goalnr} goal
    "63", //1st half - double chance
    "64", //1st half - draw no bet
    "55", //1st/2nd half both teams to score
    "14", //Handicap {hcp}
    "11", //Draw no bet
    "8", //{!goalnr} goal
    "9", //Last goal
    "12", //{$competitor1} no bet
    "13", //{$competitor2} no bet
    "65", //1st half - handicap {hcp}
    "84", //2nd half - {!goalnr} goal
    "86", //2nd half - draw no bet
    "87", //2nd half - handicap {hcp}
    "10", //Double chance
    "35", //1x2 &amp; both teams to score
    "47", //Halftime/fulltime
    "546", //Double chance &amp; both teams to score
    "78", //1st half - 1x2 &amp; both teams to score
    "63", //1st half - double chance
    "85", //2nd half - double chance
    "540", //Double chance (match) &amp; 1st half both teams score
    "541", //Double chance (match) &amp; 2nd half both teams score
    "820", //Halftime/fulltime &amp; exact goals
    "60", //1st half - 1x2,
    "88", //2nd half - handicap
    "66", //1st half - handicap
    "16", //handicap
    "184", // {!goalnr} goal &amp; 1x2
    "223", //"Handicap (incl. overtime)"
    "66", //"1st half - handicap"
    "14", // "Handicap {hcp}"
    "303", //"{!quarternr} quarter - handicap"
    "88", //"2nd half - handicap",
    "188" //"Set handicap"
  ]
};

const BETBALANCER = 1;
const ESPORT = 2;
export const FEEDPROVIDER = {
  BETBALANCER,
  ESPORT
};

export const EXTRA_MARKET_NAMES = {
  All: "SB_EXTRA_MARKET_NAMES.ALL",
  "Main Markets": "SB_EXTRA_MARKET_NAMES.MAIN_MARKETS",
  Total: "SB_EXTRA_MARKET_NAMES.TOTALS",
  "First Half": "SB_EXTRA_MARKET_NAMES.1ST_HALF",
  "Second Half": "SB_EXTRA_MARKET_NAMES.2ND_HALF",
  Score: "SB_EXTRA_MARKET_NAMES.SCORE",
  Corners: "SB_EXTRA_MARKET_NAMES.CORNERS",
  "Home Team": "SB_EXTRA_MARKET_NAMES.HOME_TEAM",
  "Away Team": "SB_EXTRA_MARKET_NAMES.AWAY_TEAM",
  "All Periods": "SB_EXTRA_MARKET_NAMES.ALL_PERIODS",
  Results: "SB_EXTRA_MARKET_NAMES.RESULTS",
  "Home / Away": "SB_EXTRA_MARKET_NAMES.HOME/AWAY"
};

const languagesCode = {
  en: "en-US",
  es: "es-ES",
  pt: "pt-PT"
};
export const getLanguageCode = (language) => {
  if (languagesCode?.[language]) {
    return languagesCode?.[language];
  }
  return languagesCode["en"];
};
export const rangeBasedmarkets = {
  PRE: [],
  LIVE: [
    "8_26", //"correct score",
    "8_520" //Correct score in set Tennis
  ]
};
export const selectionBasedMarketIds = {
  PRE: [
    "47_", //halftime/fulltime
    "540_", //"Double chance (match) &amp; 1st half both teams score"
    "541_", //"Double chance (match) &amp; 2nd half both teams score"
    "542_", //"1st half - double chance &amp; both teams to score"
    "545_", //"2nd half - double chance &amp; both teams to score"
    "546_", //"Double chance &amp; both teams to score"
    "820_", //"Halftime/fulltime &amp; exact goals",
    "819_", //"Halftime/fulltime &amp; 1st half total"
    "818_", //"Halftime/fulltime &amp; total"
    "45_", //correct score",
    "98_", //2nd half - correct score"
    "81_", //"1st half - correct score"
    "35_", //"1x2 &amp; both teams to score"
    "543_", //"2nd half - 1x2 &amp; both teams to score"
    "78_", //"1st half - 1x2 &amp; both teams to score"
    "79_", // "1st half - 1x2 &amp; total"
    "544_", // "2nd half - 1x2 &amp; total",
    "37_", //1x2 &amp; total
    "184_", // {!goalnr} goal &amp; 1x2
    "55_", //1st/2nd half both teams to score
    "17220000_", //Number of Corners in the 1st Half - 2nd Half,
    "20920000_", //Number of Corners in the 1st Half - 2nd Half,
    "199_", //"Correct score",
    "41_", //"Correct score [{score}]",
    "46_", //"Halftime/fulltime correct score"
    "547_", //"Double chance &amp; total"
    "36_" //"Total &amp; both teams to score"
  ],
  LIVE: [
    "8_237" //"Halftime/fulltime"
  ]
};
export const selectionBasedMarketWithSpace = {
  PRE: ["46_"],
  LIVE: []
};
export const totalMarkets = {
  PRE: [
    "79_", // "1st half - 1x2 &amp; total"
    "544_", // "2nd half - 1x2 &amp; total"
    "37_", //1x2 &amp; total
    "819_", //"Halftime/fulltime &amp; 1st half total"
    "547_", //"Double chance &amp; total"
    "818_" //"Halftime/fulltime &amp; total"
  ]
};

export const Disable12Translation = {
  PRE: [
    "820_" //"Halftime/fulltime &amp; exact goals"
  ]
};
export const alphabets = {
  en: "abcdefghijklmnopqrstuvwxyz".split(""),
  es: "a,b,c,d,e,f,g,h,i,j,k,l,m,n,ñ,o,p,q,r,s,t,u,v,w,x,y,z".split(","),
  pt: "abcdefghijklmnopqrstuvwxyz".split("")
};

export const extraMarketLimit = 10;
